export const SUBSCRIPTION_PLANS = [
  {
    value: "ONE_MONTH",
    name: "Starter",
    audience: "For small schools",
    tone: "slate",
    duration: "1 Month",
    price: 999,
    description: "Essential tools for a small school getting started.",
    limits: [
      { label: "Students", value: "50" },
      { label: "Staff members", value: "10" },
      { label: "Admin users", value: "2" },
      { label: "Storage", value: "5 GB" },
    ],
    features: ["Student records", "Attendance and classes", "Fee tracking", "Email support"],
    savings: "Flexible monthly access",
    badge: "",
  },
  {
    value: "THREE_MONTH",
    name: "Growth",
    audience: "For growing schools",
    tone: "blue",
    duration: "3 Months",
    price: 2699,
    description: "The right balance for growing school operations.",
    limits: [
      { label: "Students", value: "150" },
      { label: "Staff members", value: "25" },
      { label: "Admin users", value: "4" },
      { label: "Storage", value: "15 GB" },
    ],
    features: ["Everything in Starter", "Exam and timetable tools", "Parent communication", "Priority email support"],
    savings: "Save 10%",
    badge: "",
  },
  {
    value: "SIX_MONTH",
    name: "Professional",
    audience: "For established schools",
    tone: "teal",
    duration: "6 Months",
    price: 4999,
    description: "Advanced control for established school teams.",
    limits: [
      { label: "Students", value: "500" },
      { label: "Staff members", value: "60" },
      { label: "Admin users", value: "8" },
      { label: "Storage", value: "50 GB" },
    ],
    features: ["Everything in Growth", "Analytics and reports", "Advanced permissions", "Priority support queue"],
    savings: "Save 15%",
    badge: "Most Popular",
  },
  {
    value: "ONE_YEAR",
    name: "Enterprise",
    audience: "For multi-campus teams",
    tone: "indigo",
    duration: "1 Year",
    price: 8999,
    description: "Maximum capacity for large and multi-campus schools.",
    limits: [
      { label: "Students", value: "1,500" },
      { label: "Staff members", value: "150" },
      { label: "Admin users", value: "15" },
      { label: "Storage", value: "150 GB" },
    ],
    features: ["Everything in Professional", "Multi-campus readiness", "Custom permission support", "Dedicated onboarding"],
    savings: "Save 25%",
    badge: "Best Value",
  },
];

export const getSubscriptionPlan = (value) => (
  SUBSCRIPTION_PLANS.find((plan) => plan.value === value) || SUBSCRIPTION_PLANS[0]
);

export const formatInr = (amount) => `\u20B9 ${Number(amount || 0).toLocaleString("en-IN")}`;
